<template>
  <DisplayGrid size="by3-2-1" tag="div">
    <LbButtonLibrary
      v-for="child in library.children"
      :key="child.id"
      :title="child?.title"
      :subtitle="child?.subtitle"
      :description="child?.description"
      :color-code="child?.colorCode"
      :icon="child?.icon"
      :meta-color-code="child?.metaColorCode"
      :meta-content="child?.metaContent"
      :meta-icon="child?.metaIcon"
      :meta-short-title="child?.metaShortTitle"
      :meta-subtitle="child?.metaSubtitle"
      :meta-title="child?.metaTitle"
      :to="`${libraryStrategy.path.value}/${child.slug}`"
    >
    </LbButtonLibrary>
  </DisplayGrid>
</template>
<script lang="ts" setup>
const route = useRoute();

const {
  libraryManager: { library, media },
  libraryStrategy,
} = inject(INJECT_LIBRARY_PAGE_OR_FORM);
</script>
